import {
  NavigateOptions,
  useNavigate as routerUseNavigate,
  Location as ILocation,
  Params,
  useParams,
} from "react-router";
import { useAuth } from "../components";
import { PrivateRouteParams } from "../pages/invite/models";
import { AuthCustomerUser, CPContactPerson } from "../api/models/unified";

export interface LoginRouteState {
  from?: ILocation;
  originalParams?: Params<PrivateRouteParams>;
}

type PublicParams = "tenantCode";

export const useNavigate = () => {
  const navigate = routerUseNavigate();
  const params = useParams<PublicParams>();
  const { user } = useAuth();

  let rootPath = "";

  if (user) {
    rootPath = `/${user.tenantCode}/${user.customerId}/`;
  }

  if (params?.tenantCode && !user) {
    rootPath = `/${params.tenantCode}`;
  }

  return {
    goTo: async (path: string, options?: NavigateOptions) => {
      await navigate(`${rootPath}${path}`, options);
    },
    goBack: () => navigate(-1),
    goHome: () =>
      user ? navigate("/") : navigate(`/${params?.tenantCode ?? ""}`),
    goToNewCustomer: (tenantCode: string, customerId: string) =>
      navigate(`/${tenantCode}/${customerId}`),
  };
};

export const checkAccessForOtherAccount = (
  otherAccounts: CPContactPerson[],
  params?: Params<PrivateRouteParams>,
) => {
  if (params?.customerId && params.tenantCode) {
    return otherAccounts.some(
      (x) =>
        x.tenantCode === params.tenantCode &&
        x.customerId === params.customerId,
    );
  }

  return false;
};

export const getPathToNavigate = (
  user: AuthCustomerUser,
  location?: ILocation,
) => {
  if (location?.pathname?.includes(`${user.tenantCode}/${user.customerId}`)) {
    return location?.pathname ?? "/";
  } else if (user.customerId) {
    return `/${user.tenantCode}/${user.customerId}`;
  } else {
    return "/account-select";
  }
};
